import { useQuery } from '@tanstack/react-query';

import { useCurrentUser } from '@/hooks/use-current-user';
import { useLookupsService } from '@/hooks/use-lookups-service';

export const useDrugsInTherapeuticClass = (classificationId?: number) => {
  const { getProductLookups } = useLookupsService();
  const { hasPolicies, user } = useCurrentUser();
  const isInternalUser = hasPolicies(['isAnyArtiaUser']);

  return useQuery({
    queryKey: ['drugs-in-therapeutic-class', classificationId, isInternalUser, user.client?.id],
    queryFn: async () => {
      if (!classificationId) return [];
      
      const result = await getProductLookups({
        classifications: [classificationId],
        trackedByClients: isInternalUser ? [] : (user.client?.id ? [user.client.id] : []),
      });
      
      // Check if result is already an array (non-paginated) or has items property (paginated)
      return Array.isArray(result) ? result : result.items || [];
    },
    enabled: !!classificationId,
  });
};
